const cachedScripts: Record<string, Promise<void>> = {};

const loadScript = (
  src: string,
  id?: string,
  attributes?: Record<string, string>
): Promise<void> => {
  const existing = cachedScripts[src];
  if (existing) {
    return existing;
  }

  const promise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.setAttribute('nonce', CONST.CSP_NONCE);
    if (id) {
      script.id = id;
    }
    if (attributes) {
      Object.entries(attributes).forEach(([key, value]) => script.setAttribute(key, value));
    }
    const onScriptLoad = () => resolve();

    const onScriptError = () => {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      cleanup();

      delete cachedScripts[src];
      script.remove();

      reject(new Error(`Unable to load script ${src}`));
    };

    script.addEventListener('load', onScriptLoad);
    script.addEventListener('error', onScriptError);

    document.body.appendChild(script);

    function cleanup() {
      script.removeEventListener('load', onScriptLoad);
      script.removeEventListener('error', onScriptError);
    }
  });

  cachedScripts[src] = promise;

  return promise;
};

export default loadScript;
